import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import Seo from '../components/Seo';
import useHomeStore from '../store/cmsStore/homeStore';

// Lists every story from the home page's "They Found Love, So Can You" section
// (managed in the admin under Home > testimonials), so both places stay in sync.
const SlammmmLoveStories: React.FC = () => {
  const { sections, fetchSectionsList } = useHomeStore();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSectionsList();
  }, [fetchSectionsList]);

  const testimonials = sections.testimonials;
  const stories = testimonials?.loop_fields || [];

  return (
    <>
      <Seo
        title="Slammmm Love Stories | Real Couples Who Found Love"
        description="Read Slammmm Love Stories: real couples and families who met on SLAMMMM and found connections that lasted."
        canonical="https://www.slammmm.com/slammmm-love-stories"
      />

      <section className="py-100 breadcrumb_section bg-light border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto text-center">
              <div className="section_title">
                <h1 className="mb-4">Slammmm Love Stories</h1>
              </div>
              <p className="font20 mb-4">
                Real people, real connections. Read how couples and families found each other on SLAMMMM.
              </p>
              <Link to="/signup"><button className="btn btn-primary">Start Your Own Story</button></Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-100 our_values_section">
        <div className="container">
          {!testimonials?.loaded && <Skeleton height={320} count={2} className="mb-4" />}

          {stories.map((story, index) => (
            <div className="card mb-4 overflow-hidden" key={`${story.title}-${index}`}>
              <div className={`row g-0 align-items-center ${index % 2 ? 'flex-md-row-reverse' : ''}`}>
                <div className="col-md-6 p-4 p-lg-5">
                  <h2 className="font28 mb-3">{story.title}</h2>
                  <p className="mb-0 font20">{story.description}</p>
                </div>
                <div className="col-md-6">
                  <img src={story.image} alt={story.title} className="img-fluid w-100" loading="lazy" />
                  <div className="text-center p-3">
                    <Link to="/signup"><button className="btn btn-primary">Start Your Own Love Story</button></Link>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {testimonials?.loaded && stories.length === 0 && (
            <p className="text-center font20 mb-0">Love stories are coming soon.</p>
          )}
        </div>
      </section>

      <section className="py-100 love_journey_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center z-3 position-relative">
              <div className="section_title mb-3">
                <h2 className="text-white">Ready to Write Your Own Love Story?</h2>
              </div>
              <p className="text-white font20 mb-4 pb-2">
                Join SLAMMMM and meet people who share your interests, values, and relationship goals.
              </p>
              <Link to="/signup"><button className="btn btn-primary">Sign Up Free</button></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SlammmmLoveStories;
